import { useContext } from 'react';
import { MapGlobalContext } from '../context/map-global-context';

/**
 * get esri mapView ref,
 * then manipulate mapView directly https://developers.arcgis.com/javascript/latest/api-reference/esri-views-MapView.html
 * Or use `useEsriMapView` to get wrapper of some common used functions/properties
 */
export const useEsriMapViewRef = () => {
    const mapGlobalContext = useContext(MapGlobalContext);

    if (!mapGlobalContext || !mapGlobalContext.esriMapViewRef)
        throw new Error("Couldn't find esriMapViewRef");

    // store esriMapViewRef in mapGlobalContext,
    // when esri map initialized, esri `mapView` will be assigned to esriMapViewRef
    return mapGlobalContext.esriMapViewRef;
};
